<template>
  <div class="d-flex flex-column remaining-space">
    <div class="mx-2 h-100-per">
      <v-divider class="my-2" />
      <FilesTable
        v-if="session.filesData.length"
        :session="session"
        :showMoreDetailsCicked="file => (shownFile = file)"
      />

      <!--SHOW SPESIFIC FILE-->
      <MoreFileDetails
        v-if="shownFile"
        :shownFile="shownFile"
        :closeFileDetails="() => (shownFile = null)"
        :removeFileFromArray="removeFileFromArray"
      />

      
      <!-- <div class="d-flex justify-space-between align-center" tabindex="0">
        <div class="fs-1r">
          <span class="mx-2"
            >{{ $t('Total Files') }}: {{ session.filesData.length }}</span
          >
          <br
            v-if="
              $vuetify.breakpoint.width < 390 || accessibility.fontSize === 3
            "
          />
          <span class="mx-2"
            >{{ $t('Total Size') }}: {{ session.totalSize | bytesToSize }}</span
          >
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import FilesTable from '../Mobile/FilesTable/FilesTable.vue'
import MoreFileDetails from '../Mobile/MoreFileDetails/MoreFileDetails.vue'
import { alertDialog, bytesToSize } from '@/utils'
import Button from '@/components/BaseComponents/Button/Button.vue'
import Totals from '@/components/CasualInterface/CasualUpload/Totals.vue'
import { deleteItem } from '@/components/WebsiteInterface/uploadingFunctions'
import { mapGetters } from 'vuex'

export default {
  name: 'FileDirButtons',
  data() {
    return {
      shownFile: null,
    }
  },
  props: {
    session: Object,
    lightSessionRestart: Function,
  },
  filters: {
    bytesToSize,
  },
  components: { Button, FilesTable, MoreFileDetails, Totals },
  computed: {
    ...mapGetters(['accessibility', 'language', 'isDarkMode']),
  },
  methods: {
    removeFileFromArray(item) {
      //this will remove a file from the files array
      deleteItem(item, this)
      this.shownFile = null
    },
  },
}
</script>

